import PropTypes from 'prop-types';

export const selectPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  disabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  hasError: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
      ]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
      ]),
    }),
  ),
  defaultOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
      ]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
      ]),
    }),
  ),
  inputProps: PropTypes.shape({
    maxLength: PropTypes.number,
    numberOnly: PropTypes.bool,
  }),
  setFieldValue: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  setFieldTouched: PropTypes.func,
  widthDefaultSpacing: PropTypes.bool,
  isAsync: PropTypes.bool,
  cacheAsyncOptions: PropTypes.bool,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  defaultValue: PropTypes.shape({
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
    ]),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object,
    ]),
  }),
  maxLength: PropTypes.number,
  withoutIcon: PropTypes.bool,
};
